export const thongTinVatHangHoa = {
  sections: {
    list: { title: 'Product VAT info' },
  },
  titles: {
    add: 'Add VAT info',
    edit: 'Edit VAT info',
  },
  fields: {
    maSanPham: 'Product code',
    ghiChu: 'Note',
    ngayHachToan: 'Posting date',
    dienGiai: 'Description',
    loaiTien: 'Currency',
    tyGia: 'Exchange rate',
    maHangKeToan: 'Accounting item code',
    congTy: 'Company',
    tenHangKhaiVat: 'VAT declared item name',
    ghiChuMang: 'Segment note',
    tkKho: 'Inventory account',
    tkCongNo: 'Payable/Cash account',
    donViTinh: 'Unit',
    soLuong: 'Quantity',
    donGia: 'Unit price',
    thanhTien: 'Amount',
    donGiaVnd: 'Unit price (VND)',
    phanTramThueGtgt: 'VAT %',
    tienThueGtgt: 'VAT amount',
    tienThueGtgtQuyDoi: 'VAT amount (converted)',
    tkDoiUngThueGtgt: 'VAT contra account',
    tkThueGtgt: 'VAT account',
    nhomHhdvMuaVao: 'Purchased goods/services group',
    phiTruocHaiQuan: 'Pre-customs fee',
    giaTinhThueNk: 'Import duty base',
    phanTramThueNk: 'Import duty %',
    hangHoa: 'Product in system',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
  },
  filter: {
    searchPlaceholder: 'Search',
    textDetailTitle: 'Detailed filter',
    dateRangePlaceholder: 'Select date range',
    fromDate: 'From date',
    toDate: 'To date',
    noOptions: 'No data yet',
    lienKetAll: 'All',
    lienKetCo: 'Exists in system',
    lienKetKhong: 'Not in system',
  },
  filters: {
    hintSection: 'Search',
    hintBody:
      'Type a product code, accounting item code, VAT item name, description or company into the search box above.',
  },
  placeholders: {
    maSanPham: 'Search by product code or name',
    noProduct: 'No product found',
  },
  hints: {
    chuaLienKet: 'Not in system',
  },
  messages: {
    productTabEmpty: 'No VAT info for this product yet.',
    loadError: 'Could not load VAT info list.',
    noData: 'No product VAT info yet.',
    listSummary: 'Total {count} rows',
    saveSuccess: 'VAT info saved.',
    deleteSuccess: 'VAT info row deleted.',
    confirmDelete: 'Delete the VAT info row of code "{name}"?',
    selectedCount: '{count} selected',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm: 'Delete {count} selected VAT info rows?',
    bulkDeleteSuccess: 'Deleted {count} rows',
    bulkDeleteError: 'Bulk delete failed',
  },
  validation: {
    maSanPhamRequired: 'Please enter the product code.',
  },
  import: {
    description:
      'Download the template and fill it in using the exact column headers (row 1). Numbers accept 4.216 / 0,16 formats. Posting date as dd/mm/yyyy; leave blank or 00/01/1900 if none. If any row has errors, nothing is imported.',
    cheDoNhap: 'Import mode',
    cheDoThemMoi: 'Append — keep existing rows',
    cheDoThayThe: 'Replace — delete existing rows of product codes in the file, then import',
    success: 'VAT info imported successfully.',
    failed: 'VAT info import failed.',
  },
}
